// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/inventory/v1/inventory_alerts.proto" (package "c1.api.inventory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppResourceRef } from "../../app/v1/app_resource";
import { AppUserRef } from "../../app/v1/app_user";
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchInventoryAlertsRequest
 */
export interface SearchInventoryAlertsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 3
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6
     */
    appResourceRefs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.inventory.v1.SearchInventoryAlertsRequest.Status status = 7
     */
    status: SearchInventoryAlertsRequest_Status;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 8
     */
    expandMask?: InventoryAlertExpandMask;
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.SearchInventoryAlertsRequest.Status
 */
export enum SearchInventoryAlertsRequest_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: STATUS_RESOLVED = 2;
     */
    RESOLVED = 2
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest
 */
export interface SearchHistoricalInventoryAlertsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 3
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6
     */
    appResourceRefs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 7
     */
    expandMask?: InventoryAlertExpandMask;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlertExpandMask
 */
export interface InventoryAlertExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchInventoryAlertsResponse
 */
export interface SearchInventoryAlertsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.inventory.v1.InventoryAlertView list = 1
     */
    list: InventoryAlertView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlertView
 */
export interface InventoryAlertView {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlert inventory_alert = 1
     */
    inventoryAlert?: InventoryAlert;
    /**
     * @generated from protobuf field: string resource_path = 2
     */
    resourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_user_path = 5
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse
 */
export interface SearchHistoricalInventoryAlertsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.inventory.v1.HistoricalInventoryAlertView list = 1
     */
    list: HistoricalInventoryAlertView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.HistoricalInventoryAlertView
 */
export interface HistoricalInventoryAlertView {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.HistoricalInventoryAlert historical_inventory_alert = 1
     */
    historicalInventoryAlert?: HistoricalInventoryAlert;
    /**
     * @generated from protobuf field: string resource_path = 2
     */
    resourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_user_path = 5
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.AlertMetadata
 */
export interface AlertMetadata {
    /**
     * @generated from protobuf field: string identity_app_user_id = 1
     */
    identityAppUserId: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.AlertData
 */
export interface AlertData {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertStatus status = 1
     */
    status: InventoryAlertStatus;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertType type = 2
     */
    type: InventoryAlertType;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertSeverity severity = 3
     */
    severity: InventoryAlertSeverity;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertMetadata metadata = 4
     */
    metadata?: AlertMetadata;
    /**
     * @generated from protobuf oneof: subject
     */
    subject: {
        oneofKind: "appResourceRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppResourceRef app_resource_ref = 100
         */
        appResourceRef: AppResourceRef;
    } | {
        oneofKind: "appUserRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserRef app_user_ref = 101
         */
        appUserRef: AppUserRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlert
 */
export interface InventoryAlert {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string scope_id = 3
     */
    scopeId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertData data = 7
     */
    data?: AlertData;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.HistoricalInventoryAlert
 */
export interface HistoricalInventoryAlert {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string scope_id = 3
     */
    scopeId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp detected_at = 7
     */
    detectedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertData data = 8
     */
    data?: AlertData;
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertStatus
 */
export enum InventoryAlertStatus {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_RESOLVED = 2;
     */
    RESOLVED = 2
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertType
 */
export enum InventoryAlertType {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * reserved
     *
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNUSED_SECRET = 1;
     */
    UNUSED_SECRET = 1,
    /**
     * reserved
     *
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_DEACTIVATED_OWNER = 2;
     */
    DEACTIVATED_OWNER = 2,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNUSED_SECRET_API_TOKEN = 3;
     */
    UNUSED_SECRET_API_TOKEN = 3,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_DEACTIVATED_ACCOUNT_OWNER = 4;
     */
    DEACTIVATED_ACCOUNT_OWNER = 4
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertSeverity
 */
export enum InventoryAlertSeverity {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_LOW = 1;
     */
    LOW = 1,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_MEDIUM = 2;
     */
    MEDIUM = 2,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_HIGH = 3;
     */
    HIGH = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryAlertsRequest$Type extends MessageType<SearchInventoryAlertsRequest> {
    constructor() {
        super("c1.api.inventory.v1.SearchInventoryAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "app_resource_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "status", kind: "enum", T: () => ["c1.api.inventory.v1.SearchInventoryAlertsRequest.Status", SearchInventoryAlertsRequest_Status, "STATUS_"] },
            { no: 8, name: "expand_mask", kind: "message", T: () => InventoryAlertExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryAlertsRequest>): SearchInventoryAlertsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appIds = [];
        message.appUserRefs = [];
        message.identityAppUserRefs = [];
        message.appResourceRefs = [];
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryAlertsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryAlertsRequest): SearchInventoryAlertsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string app_ids */ 3:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 4:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs */ 5:
                    message.identityAppUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppResourceRef app_resource_refs */ 6:
                    message.appResourceRefs.push(AppResourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.inventory.v1.SearchInventoryAlertsRequest.Status status */ 7:
                    message.status = reader.int32();
                    break;
                case /* c1.api.inventory.v1.InventoryAlertExpandMask expand_mask */ 8:
                    message.expandMask = InventoryAlertExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryAlertsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string app_ids = 3; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 4; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5; */
        for (let i = 0; i < message.identityAppUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.identityAppUserRefs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6; */
        for (let i = 0; i < message.appResourceRefs.length; i++)
            AppResourceRef.internalBinaryWrite(message.appResourceRefs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.inventory.v1.SearchInventoryAlertsRequest.Status status = 7; */
        if (message.status !== 0)
            writer.tag(7, WireType.Varint).int32(message.status);
        /* c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 8; */
        if (message.expandMask)
            InventoryAlertExpandMask.internalBinaryWrite(message.expandMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchInventoryAlertsRequest
 */
export const SearchInventoryAlertsRequest = new SearchInventoryAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchHistoricalInventoryAlertsRequest$Type extends MessageType<SearchHistoricalInventoryAlertsRequest> {
    constructor() {
        super("c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "app_resource_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => InventoryAlertExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchHistoricalInventoryAlertsRequest>): SearchHistoricalInventoryAlertsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appIds = [];
        message.appUserRefs = [];
        message.identityAppUserRefs = [];
        message.appResourceRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchHistoricalInventoryAlertsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchHistoricalInventoryAlertsRequest): SearchHistoricalInventoryAlertsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string app_ids */ 3:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 4:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs */ 5:
                    message.identityAppUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppResourceRef app_resource_refs */ 6:
                    message.appResourceRefs.push(AppResourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.inventory.v1.InventoryAlertExpandMask expand_mask */ 7:
                    message.expandMask = InventoryAlertExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchHistoricalInventoryAlertsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string app_ids = 3; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 4; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5; */
        for (let i = 0; i < message.identityAppUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.identityAppUserRefs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6; */
        for (let i = 0; i < message.appResourceRefs.length; i++)
            AppResourceRef.internalBinaryWrite(message.appResourceRefs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 7; */
        if (message.expandMask)
            InventoryAlertExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest
 */
export const SearchHistoricalInventoryAlertsRequest = new SearchHistoricalInventoryAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlertExpandMask$Type extends MessageType<InventoryAlertExpandMask> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlertExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_resource", "app_resource_type", "app", "app_user"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<InventoryAlertExpandMask>): InventoryAlertExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<InventoryAlertExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryAlertExpandMask): InventoryAlertExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryAlertExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlertExpandMask
 */
export const InventoryAlertExpandMask = new InventoryAlertExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryAlertsResponse$Type extends MessageType<SearchInventoryAlertsResponse> {
    constructor() {
        super("c1.api.inventory.v1.SearchInventoryAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InventoryAlertView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryAlertsResponse>): SearchInventoryAlertsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryAlertsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryAlertsResponse): SearchInventoryAlertsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.inventory.v1.InventoryAlertView list */ 1:
                    message.list.push(InventoryAlertView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryAlertsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.inventory.v1.InventoryAlertView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            InventoryAlertView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchInventoryAlertsResponse
 */
export const SearchInventoryAlertsResponse = new SearchInventoryAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlertView$Type extends MessageType<InventoryAlertView> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlertView", [
            { no: 1, name: "inventory_alert", kind: "message", T: () => InventoryAlert },
            { no: 2, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InventoryAlertView>): InventoryAlertView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourcePath = "";
        message.appPath = "";
        message.appResourceTypePath = "";
        message.appUserPath = "";
        if (value !== undefined)
            reflectionMergePartial<InventoryAlertView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryAlertView): InventoryAlertView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.inventory.v1.InventoryAlert inventory_alert */ 1:
                    message.inventoryAlert = InventoryAlert.internalBinaryRead(reader, reader.uint32(), options, message.inventoryAlert);
                    break;
                case /* string resource_path */ 2:
                    message.resourcePath = reader.string();
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 4:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_user_path */ 5:
                    message.appUserPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryAlertView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.inventory.v1.InventoryAlert inventory_alert = 1; */
        if (message.inventoryAlert)
            InventoryAlert.internalBinaryWrite(message.inventoryAlert, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string resource_path = 2; */
        if (message.resourcePath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourcePath);
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string app_resource_type_path = 4; */
        if (message.appResourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_user_path = 5; */
        if (message.appUserPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlertView
 */
export const InventoryAlertView = new InventoryAlertView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchHistoricalInventoryAlertsResponse$Type extends MessageType<SearchHistoricalInventoryAlertsResponse> {
    constructor() {
        super("c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HistoricalInventoryAlertView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchHistoricalInventoryAlertsResponse>): SearchHistoricalInventoryAlertsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchHistoricalInventoryAlertsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchHistoricalInventoryAlertsResponse): SearchHistoricalInventoryAlertsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.inventory.v1.HistoricalInventoryAlertView list */ 1:
                    message.list.push(HistoricalInventoryAlertView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchHistoricalInventoryAlertsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.inventory.v1.HistoricalInventoryAlertView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            HistoricalInventoryAlertView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse
 */
export const SearchHistoricalInventoryAlertsResponse = new SearchHistoricalInventoryAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HistoricalInventoryAlertView$Type extends MessageType<HistoricalInventoryAlertView> {
    constructor() {
        super("c1.api.inventory.v1.HistoricalInventoryAlertView", [
            { no: 1, name: "historical_inventory_alert", kind: "message", T: () => HistoricalInventoryAlert },
            { no: 2, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HistoricalInventoryAlertView>): HistoricalInventoryAlertView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourcePath = "";
        message.appPath = "";
        message.appResourceTypePath = "";
        message.appUserPath = "";
        if (value !== undefined)
            reflectionMergePartial<HistoricalInventoryAlertView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HistoricalInventoryAlertView): HistoricalInventoryAlertView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.inventory.v1.HistoricalInventoryAlert historical_inventory_alert */ 1:
                    message.historicalInventoryAlert = HistoricalInventoryAlert.internalBinaryRead(reader, reader.uint32(), options, message.historicalInventoryAlert);
                    break;
                case /* string resource_path */ 2:
                    message.resourcePath = reader.string();
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 4:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_user_path */ 5:
                    message.appUserPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HistoricalInventoryAlertView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.inventory.v1.HistoricalInventoryAlert historical_inventory_alert = 1; */
        if (message.historicalInventoryAlert)
            HistoricalInventoryAlert.internalBinaryWrite(message.historicalInventoryAlert, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string resource_path = 2; */
        if (message.resourcePath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourcePath);
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string app_resource_type_path = 4; */
        if (message.appResourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_user_path = 5; */
        if (message.appUserPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.HistoricalInventoryAlertView
 */
export const HistoricalInventoryAlertView = new HistoricalInventoryAlertView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertMetadata$Type extends MessageType<AlertMetadata> {
    constructor() {
        super("c1.api.inventory.v1.AlertMetadata", [
            { no: 1, name: "identity_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AlertMetadata>): AlertMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identityAppUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AlertMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertMetadata): AlertMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identity_app_user_id */ 1:
                    message.identityAppUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identity_app_user_id = 1; */
        if (message.identityAppUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identityAppUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.AlertMetadata
 */
export const AlertMetadata = new AlertMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertData$Type extends MessageType<AlertData> {
    constructor() {
        super("c1.api.inventory.v1.AlertData", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertStatus", InventoryAlertStatus, "INVENTORY_ALERT_STATUS_"] },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertType", InventoryAlertType, "INVENTORY_ALERT_TYPE_"] },
            { no: 3, name: "severity", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertSeverity", InventoryAlertSeverity, "INVENTORY_ALERT_SEVERITY_"] },
            { no: 4, name: "metadata", kind: "message", T: () => AlertMetadata },
            { no: 100, name: "app_resource_ref", kind: "message", oneof: "subject", T: () => AppResourceRef },
            { no: 101, name: "app_user_ref", kind: "message", oneof: "subject", T: () => AppUserRef }
        ]);
    }
    create(value?: PartialMessage<AlertData>): AlertData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.type = 0;
        message.severity = 0;
        message.subject = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AlertData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertData): AlertData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.inventory.v1.InventoryAlertStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* c1.api.inventory.v1.InventoryAlertType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* c1.api.inventory.v1.InventoryAlertSeverity severity */ 3:
                    message.severity = reader.int32();
                    break;
                case /* c1.api.inventory.v1.AlertMetadata metadata */ 4:
                    message.metadata = AlertMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* c1.api.app.v1.AppResourceRef app_resource_ref */ 100:
                    message.subject = {
                        oneofKind: "appResourceRef",
                        appResourceRef: AppResourceRef.internalBinaryRead(reader, reader.uint32(), options, (message.subject as any).appResourceRef)
                    };
                    break;
                case /* c1.api.app.v1.AppUserRef app_user_ref */ 101:
                    message.subject = {
                        oneofKind: "appUserRef",
                        appUserRef: AppUserRef.internalBinaryRead(reader, reader.uint32(), options, (message.subject as any).appUserRef)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.inventory.v1.InventoryAlertStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* c1.api.inventory.v1.InventoryAlertType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* c1.api.inventory.v1.InventoryAlertSeverity severity = 3; */
        if (message.severity !== 0)
            writer.tag(3, WireType.Varint).int32(message.severity);
        /* c1.api.inventory.v1.AlertMetadata metadata = 4; */
        if (message.metadata)
            AlertMetadata.internalBinaryWrite(message.metadata, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResourceRef app_resource_ref = 100; */
        if (message.subject.oneofKind === "appResourceRef")
            AppResourceRef.internalBinaryWrite(message.subject.appResourceRef, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserRef app_user_ref = 101; */
        if (message.subject.oneofKind === "appUserRef")
            AppUserRef.internalBinaryWrite(message.subject.appUserRef, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.AlertData
 */
export const AlertData = new AlertData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlert$Type extends MessageType<InventoryAlert> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlert", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "data", kind: "message", T: () => AlertData, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
    create(value?: PartialMessage<InventoryAlert>): InventoryAlert {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.id = "";
        message.scopeId = "";
        if (value !== undefined)
            reflectionMergePartial<InventoryAlert>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryAlert): InventoryAlert {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string scope_id */ 3:
                    message.scopeId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.inventory.v1.AlertData data */ 7:
                    message.data = AlertData.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryAlert, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string scope_id = 3; */
        if (message.scopeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scopeId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.inventory.v1.AlertData data = 7; */
        if (message.data)
            AlertData.internalBinaryWrite(message.data, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlert
 */
export const InventoryAlert = new InventoryAlert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HistoricalInventoryAlert$Type extends MessageType<HistoricalInventoryAlert> {
    constructor() {
        super("c1.api.inventory.v1.HistoricalInventoryAlert", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "detected_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "data", kind: "message", T: () => AlertData, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
    create(value?: PartialMessage<HistoricalInventoryAlert>): HistoricalInventoryAlert {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.id = "";
        message.scopeId = "";
        if (value !== undefined)
            reflectionMergePartial<HistoricalInventoryAlert>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HistoricalInventoryAlert): HistoricalInventoryAlert {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string scope_id */ 3:
                    message.scopeId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp detected_at */ 7:
                    message.detectedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.detectedAt);
                    break;
                case /* c1.api.inventory.v1.AlertData data */ 8:
                    message.data = AlertData.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HistoricalInventoryAlert, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string scope_id = 3; */
        if (message.scopeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scopeId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp detected_at = 7; */
        if (message.detectedAt)
            Timestamp.internalBinaryWrite(message.detectedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.inventory.v1.AlertData data = 8; */
        if (message.data)
            AlertData.internalBinaryWrite(message.data, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.HistoricalInventoryAlert
 */
export const HistoricalInventoryAlert = new HistoricalInventoryAlert$Type();
/**
 * @generated ServiceType for protobuf service c1.api.inventory.v1.InventoryAlertSearch
 */
export const InventoryAlertSearch = new ServiceType("c1.api.inventory.v1.InventoryAlertSearch", [
    { name: "SearchInventoryAlerts", options: { "authz.method": { role: "VIEWER" } }, I: SearchInventoryAlertsRequest, O: SearchInventoryAlertsResponse },
    { name: "SearchHistoricalInventoryAlerts", options: { "authz.method": { role: "VIEWER" } }, I: SearchHistoricalInventoryAlertsRequest, O: SearchHistoricalInventoryAlertsResponse }
]);
